export default __webpack_public_path__ + "static/media/my_journey_part1_3.3f91e502.png";